/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Rediger",
  "i18n.actionBar.removeImage": "Fjern",
  "i18n.actionBar.swapImage": "Byt",
  "i18n.additionalInfoItemLayers.smartSorted.new": "Nyhed!",
  "i18n.additionalProducts.addToCart": "Tilføj til ordre",
  "i18n.additionalProducts.frame.description": "Aluminiumsramme af høj kvalitet: mat sølv, ægte premiumglas, ingen lim nødvendig",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tips:",
  "i18n.additionalProducts.frame.subtitle": "Det færdige puslespil er et fantastisk minde – perfekt fremhævet med vores <b>ramme</b>.",
  "i18n.additionalProducts.frame2023.description": "Træfiberramme af høj kvalitet – nem at samle, uden glas, inkl. puslespilslim",
  "i18n.additionalProducts.framePlastic.description": "Aluminiumsramme af høj kvalitet: mat sølv, antireflekterende akrylglas, ingen lim nødvendig",
  "i18n.additionalProducts.glue.description": "Til op til to puslespil med 1000 brikker, inkl. påføringssvamp",
  "i18n.additionalProducts.glue.hook": "Så bliver dit puslespil til et billede.\nLimer og beskytter permanent.",
  "i18n.additionalProducts.roll.description": "Til puslespil fra 48 til 2000 brikker",
  "i18n.additionalProducts.roll.hook": "Intet ledigt bord? Intet problem.\nRul puslespillet sammen, læg det væk og fortsæt senere.",
  "i18n.adventCalendarOverlay.activate": "Vis forklaringsvideo med de 24 låger",
  "i18n.adventCalendarOverlay.deactivate": "Luk for forklaringsvideo med de 24 låger",
  "i18n.adventCalendarOverlay.notice": "(tal og linier bliver ikke trykt med)",
  "i18n.button.addToCart": "Føj til indkøbskurv",
  "i18n.button.apply": "Anvend",
  "i18n.button.back": "Tilbage",
  "i18n.button.cancel": "Annuller",
  "i18n.button.cancelAndFix": "Ændr nu",
  "i18n.button.chooseSmartSorted": "Upgrade til SMART SORTED ",
  "i18n.button.close": "Luk",
  "i18n.button.continue": "Fortsæt",
  "i18n.button.createNewTextPlaceholders": "Tilføj tekst",
  "i18n.button.ignore": "Ignorer",
  "i18n.button.ignoreAndContinue": "Fortsæt alligevel",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nej tak, luk vindue",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Billeder",
  "i18n.button.retry": "Prøv igen",
  "i18n.button.uploadPhotos": "Upload billede(r)",
  "i18n.button.withSmartSorted": "Upgrade til SMART SORTED ",
  "i18n.button.withoutSmartSorted": "Nej tak, luk vindue",
  "i18n.control.colorChooser.color": "Farve",
  "i18n.control.fontChooser.placeholderText": "Skrifttype",
  "i18n.control.imageQuality.checkImages": "Tjek billedopløsning",
  "i18n.control.imageQuality.imageSuitability": "Billedkvalitet:",
  "i18n.control.imageQuality.indicatorAltText": "Billedkvalitet",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Vælg design",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "For at få en bedre læsbarhed, skal du forkorte længden af teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Den valgte skrifttype er for stor til denne tekst.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Den maksimale skriftstørrelse for denne tekst er nået.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Den minimale skriftstørrelse for denne tekst er nået.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Indsæt venligst et linjeskift",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Fortsæt med at skrive på en anden linje eller ødelæg tekstfeltet.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Kontrollér din tekst, ikke alle tegn understøttes af denne skrifttype.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Det maksimale antal tegn er nået",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "For at få en bedre læsbarhed, skal du forkorte længden af teksten/linjen.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Hvis du venligst gøre tekstfeltet større",
  "i18n.dialog.deletePlaceholder.message": "Denne ændring kan ikke fortrydes",
  "i18n.dialog.deletePlaceholder.title": "Slette plads holderen?",
  "i18n.dialog.error.title": [
    "Der opstod en fejl",
    "Der opstod nogle fejl"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Opløsningen på dette billede er for lav til at trykke motivet optimalt!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED lægger I jeres puslespilsmotiv med 1000 brikker på en innovativ og ubesværet måde, også uden skabelon af motivet",
  "i18n.dialog.smartSorted.title": "En garanteret succesoplevelse med dit puslespil",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klik på \"{{text}}\", for at ændre æskens titel.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Æskens titel er ikke blevet ændret.",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsæt uden en titel på æsken",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Indsæt et billede ved at klikke på pladsholderen",
    "Indsæt billeder ved at klikke på pladsholderne"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "En pladsholder er stadig tom",
    "Nogle pladsholdere er stadig tomme"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En pladsholder er ikke blevet ændret",
    "Flere pladsholdere er ikke blevet ændret."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Klik på billed-  eller tekstpladsholderen for at ændre din collage",
    "Klik på billed- og tekstpladsholderne for at ændre din collage"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "En pladsholder er ikke blevet ændret",
    "Nogle pladsholdere er ikke blevet ændret"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Klik på tekstpladsholderen for at ændre din tekst",
    "Klik på tekstpladsholderne for at ændre dine tekster"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "En tekstpladsholder er ikke blevet ændret",
    "Nogle tekstpladsholdere er ikke blevet ændret"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "uændrede pladsholdere",
  "i18n.error.additionalInfoItemsError.message": "loading error information layer",
  "i18n.error.additionalInfoItemsError.title": "Indlæsningsfejl",
  "i18n.error.deprecatedBrowserError.message": "Den browser, du bruger, understøttes ikke længere. Opdater venligst til en nyere version.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Du afbrød oprettelsen i længere tid. Den kan ikke fortsættes. Start venligst processen igen.",
  "i18n.error.designerExpiredError.title": "Din oprettelse er blevet afbrudt. ",
  "i18n.error.fontLoadingError.message": "En skrifttype kunne ikke indlæses",
  "i18n.error.fontLoadingError.title": "Indlæsningsfejl",
  "i18n.error.imageLoadingError.message": "Et billede kunne ikke indlæses.  Det blev fjernet fra designområdet og galleriet.",
  "i18n.error.imageLoadingError.title": "Downloadfejl",
  "i18n.error.imageProvisionError.message": "Ét eller flere billeder kunne ikke behandles. Medietypen er sandsynligvis ikke understøttet",
  "i18n.error.imageProvisionError.title": "Et billede kunne ikke behandles.",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunne ikke behandles",
  "i18n.error.imageSelectionError.title": "Fejl under overførsel af billede",
  "i18n.error.imageSizeLimitExceededError.message": "Det billedede, som du har uploaded, er for stor. \nVenligst sørg for, at billedet har en maksimal størrelse på 180 megapixels og prøv igen.",
  "i18n.error.imageSizeLimitExceededError.title": "Fejl under overførsel af billede",
  "i18n.error.imageUploadError.message": "Der opstod et problem med internetforbindelsen.\nPrøv igen senere.",
  "i18n.error.imageUploadError.title": "Fejl under overførsel af billede",
  "i18n.error.inlineSVGLoadingError.message": "Tolerancerammen \"{{reference1}}\" kunne ikke indlæses.",
  "i18n.error.inlineSVGLoadingError.title": "Downloadfejl",
  "i18n.error.invalidCharConfigError.message": "Denne skrifttype er ikke relevant, vælg venligst en anden skrifttype.",
  "i18n.error.invalidCharConfigError.title": "Skrifttype ikke relevant",
  "i18n.error.malformedProductError.message": "Et eller flere produkter kunne ikke overføres til vores server. Det er muligt, at produktet ikke længere er tilgængeligt, eller at forberedelsen af produktet har taget for lang tid. Du skal nu starte igen. Vi beklager ulejligheden.",
  "i18n.error.malformedProductError.title": "Indlæsningsfejl",
  "i18n.error.notInStockError.message": "Bestilling af denne vare er ikke mulig i øjeblikket.\nVed at klikke på vores logo oppe til venstre kommer du tilbage til startsiden. Der kan du vælge en anden vare.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Din internetforbindelse er blevet afbrudt. Du kan fortsætte med at designe dit produkt, så snart din forbindelse er blevet genoprettet.",
  "i18n.error.templateLoadingError.message": "Skabelonen \"{{ error.reference[0] }}\" kunne ikke indlæses.\nPrøv igen senere.",
  "i18n.error.templateLoadingError.title": "Downloadfejl",
  "i18n.error.transformationError.message": "Transformationen kunne ikke blive anvendt",
  "i18n.error.transformationError.title": "Fejl ved transformation",
  "i18n.error.traudlLoadingError.message": "Prøv igen, eller brug et andet billede.",
  "i18n.error.traudlLoadingError.title": "Et AI-filter kunne ikke anvendes.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" har en ikke-understøttet medietype.",
  "i18n.error.unsupportedMediaTypeError.title": "Fejl under overførsel af billede",
  "i18n.error.uploadProductError.message": "Et eller flere produkter kunne ikke overføres til serveren. Prøv igen senere.",
  "i18n.error.uploadProductError.title": "Fejl under overførsel",
  "i18n.error.zoomModeError.message": "Teksten fra dit tidligere layout kunne ikke vedtages. Indtast venligst en ny tekst.",
  "i18n.error.zoomModeError.title": "Tekst ikke vedtaget",
  "i18n.gallery.uploadPhotos.info": "Klik venligst på knappen \"Upload billede(r)\"",
  "i18n.gallery.uploadProgress": [
    "Uploader billede...",
    "Uploadede billeder: {{current}} af {{total}}"
  ],
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparer",
  "i18n.price.total": "Pris i alt",
  "i18n.priceDisplay.times": [
    "{{value}} produkt til {{pricePerUnit}} hver",
    "{{value}} produkter til {{pricePerUnit}} hver"
  ],
  "i18n.progress.stepAdditionalProducts": "Tilbehør (valgfrit)",
  "i18n.progressOverlay.message.lines.one": "Tak for dit design",
  "i18n.progressOverlay.message.lines.two": "Vi forbereder følgende trin for dig ...",
  "i18n.template.insertText": "Indtast din tekst her",
  "i18n.toolbox.gallery.title": "Vælg billeder",
  "i18n.toolbox.image.title": "Rediger billede",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 billede",
    "{{value}} billeder"
  ],
  "i18n.toolbox.layout.title": "Skift design",
  "i18n.toolbox.layout.triggerText": "Design",
  "i18n.toolbox.preview.title": "3D-forhåndsvisning",
  "i18n.toolbox.productChooser.title": "Skift produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Rediger tekst"
};


export class LocaleDaDK {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
